module.exports = __webpack_public_path__ + "static/img/planet.a532140.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/mall/planet.png
// module id = n6Yv
// module chunks = 1